import { createContext, useContext } from "react";

export interface VerifiedOnboarding {
  token: string;
  email: string;
  firstName?: string;
  lastName?: string;
  onboardingReferenceId?: string;
}

// In-memory only, populated after successful server OTP validation.
export const VerifiedOnboardingContext = createContext<VerifiedOnboarding | null>(null);
export const useVerifiedOnboarding = () => useContext(VerifiedOnboardingContext);
